
const digest = 'f7f5f05a9d91ed0dd93c9e9089892380caddbb4f82b29c76714167f9c06c1213';
const classes = {"wrapper":"_wrapper_x9bwk_1"};
const css = `._wrapper_x9bwk_1 {
  background: #ffffff;
  display: flex;
  border: 1px solid #eaedf3;
  padding: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  